export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "by_agro_exporter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agro exportadoras"])},
          "by_producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productores"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of processes"])},
          "by_agro_exporter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agro exporters"])},
          "by_producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producers"])}
        }
      }
    }
  })
}